import { FC, PropsWithChildren } from "react";
import cn from "classnames";
import styles from "./NavTag.module.scss";
import { NavTagProps } from "./NavTag.props";

/**
 * The navigation item tag component.
 */
export const NavTag: FC<PropsWithChildren<NavTagProps>> = (props: PropsWithChildren<NavTagProps>): JSX.Element => {
  const { children, className, id, testId } = props;

  const navTagClasses = cn("nav-tag", styles.navTag, className);

  return (
    <div id={id} data-testid={testId ? `test__${testId}-nav-title` : undefined} className={navTagClasses}>
      {children}
    </div>
  );
};
